import React, { useState } from "react";
import ManageQuestionnaires from "./ManageQuestionnaires";
import QuestionnaireBuilder from "./QuestionnaireBuilder";
import { Questionnaires } from "../_constant";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";

const QuestionnaireManager = () => {
  const [templates, setTemplates] = useState(Questionnaires);

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [unsavedTemplate, setUnsavedTemplate] = useState(null);

  const [clinic] = useAtom(clinicAtom);

  const { data: allClinicsDoctor } = useItemsFilter(
    ApiEndPoint.CLINIC,
    `?action=getClinicDoctor&clinic_id=${clinic.id}&id=${clinic.id}&backend=True`
  );

  const { data: allTemplates } = useItemsFilter(
    ApiEndPoint.CONSULTATION,
    `?action=getPreconsultationTemplete&clinic_id=${clinic.id}&backend=True`
  );

  // console.log(allTemplates);

  const handleSelectTemplate = (template) => {
    setSelectedTemplate(template);
    setUnsavedTemplate(template);
  };

  const handleBackToManage = () => {
    setSelectedTemplate(null);
  };

  const handleSaveCurrentTemplate = () => {
    setTemplates((prev) =>
      prev.map((template) =>
        template.template_id === unsavedTemplate.template_id
          ? unsavedTemplate
          : template
      )
    );
    setUnsavedTemplate(null);
  };

  const handleDiscardCurrentTemplate = () => {
    setUnsavedTemplate(null);
  };

  const handleUpdateTemplate = (updatedTemplate) => {
    setUnsavedTemplate(updatedTemplate);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="w-1/4 p-4 bg-white border-r">
        <ManageQuestionnaires
          templates={allTemplates}
          onTemplateSelect={handleSelectTemplate}
          currentTemplate={unsavedTemplate}
          onSaveCurrentTemplate={handleSaveCurrentTemplate}
          onDiscardCurrentTemplate={handleDiscardCurrentTemplate}
          clinic_id={clinic.id}
        />
      </div>

      <div className="flex-1 p-4">
        {selectedTemplate ? (
          <QuestionnaireBuilder
            template={unsavedTemplate || selectedTemplate}
            setTemplate={handleUpdateTemplate}
            onBack={handleBackToManage}
            doctors={allClinicsDoctor}
            clinic_id={clinic.id}
          />
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-gray-600 text-lg">
              Select a template to edit or create a new one.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionnaireManager;
